module.exports = __webpack_public_path__ + "static/logo-21f9d743167db3edf6d39d62547f351c.png";